import React, { KeyboardEvent, MouseEvent } from 'react'
import { SearchViewTypes } from './SearchResultsSection'
import { FormatNumber } from '../utils'

export type SectionTitleProps = {
  activeViewType: string
  sectionNumber?: string
  sectionTitle?: string
  sectionTotalHits?: number
  sectionType: string
  showBackLink?: boolean
  showViewControls?: boolean
  showPrintButton?: boolean
  handleBackClick?: (e: MouseEvent | KeyboardEvent) => void
  handleViewTypeClick?: (viewType: string, sectionType: string) => void
  togglePrintOverlay: () => void
}

const handlePrintKeyPress = (
  e: React.KeyboardEvent<HTMLElement>,
  togglePrintOverlay: () => void
) => {
  if (e.key === ' ' || e.key === 'Enter') {
    e.preventDefault()
    togglePrintOverlay()
  }
}

export const SectionTitle = ({
  activeViewType,
  sectionNumber,
  sectionTitle,
  sectionTotalHits,
  sectionType,
  showBackLink = false,
  showViewControls = false,
  showPrintButton = false,
  handleBackClick = () => {},
  handleViewTypeClick = () => {},
  togglePrintOverlay = () => {}
}: SectionTitleProps) => (
  <div className="column__left">
    <div className="section__number">{sectionNumber}</div>
    <h4 className="heading--6 search__section-heading">{sectionTitle}</h4>
    {sectionTotalHits ? (
      <p className="search__results-count">
        {FormatNumber(sectionTotalHits)} Results
      </p>
    ) : null}
    {showViewControls ? (
      <p>
        <span
          className="link--3"
          onClick={() => handleViewTypeClick(SearchViewTypes.GRID, sectionType)}
          onKeyUp={() => handleViewTypeClick(SearchViewTypes.GRID, sectionType)}
          role="button"
          style={{
            fontWeight: activeViewType === SearchViewTypes.GRID ? 900 : 600,
            backgroundColor: 'none'
          }}
          tabIndex={0}
        >
          <i className="fas fa-grip-horizontal" /> - Grid View
        </span>
        <br />
        <span
          className="link--3"
          onClick={() => handleViewTypeClick(SearchViewTypes.DATA, sectionType)}
          onKeyUp={() => handleViewTypeClick(SearchViewTypes.DATA, sectionType)}
          role="button"
          style={{
            fontWeight: activeViewType === SearchViewTypes.DATA ? 900 : 600,
            backgroundColor: 'none'
          }}
          tabIndex={0}
        >
          <i className="fas fa-list" /> - Data View
        </span>
      </p>
    ) : null}
    {showBackLink ? (
      <p>
        <span
          className="link--3"
          onClick={(e) => handleBackClick(e)}
          onKeyUp={(e) => handleBackClick(e)}
          role="button"
          tabIndex={0}
        >
          <i className="fas fa-caret-left" /> Back to results
        </span>
      </p>
    ) : null}
    {showPrintButton ? (
      <div className="social-icons">
        <i
          className="fas fa-print"
          onClick={() => togglePrintOverlay()}
          onKeyUp={(e) => handlePrintKeyPress(e, togglePrintOverlay)}
          role="button"
          tabIndex={0}
        />
      </div>
    ) : null}
  </div>
)
export default SectionTitle
